import { Segment } from "./Segment";
import { Vector } from "./Vector";
import { Point } from "./Point";


export class UndoPoint {


    Segments = new Array<Segment>();
    LabelOffsets: { [key: string]: Vector } = {};
    Points = new Array<Point>();
    ReversePaintIndicator = false;

    constructor(segments: Segment[], labelOffsets: { [key: string]: Vector }, points: Point[], reversePaintIndiacator: boolean) {
        for (let i = 0; i < segments.length; i++) {
            const segment = segments[i];
            this.Segments.push(segment.clone());
        }

        for (let key in labelOffsets) {
            let value = labelOffsets[key];
            // Use `key` and `value`
            //this.LableOffsets[key] = new Vector(offset.x, offset.y);
            //let n[key] = value;
            this.LabelOffsets[key] = value.clone();
        }

        for (let i = 0; i < points.length; i++) {
            const point = points[i];
            this.Points.push(point.clone());
        }

        this.ReversePaintIndicator = reversePaintIndiacator;
    }




}